import React from 'react';
import './navfooter.css'

const Navsfooter = (props) => {
    return ( 
        <li className='navs-footer'>{props.title}</li>
     );
}
 
export default Navsfooter;